import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-technicalservice',
  templateUrl: './home-technicalservice.component.html',
  styleUrls: ['./home-technicalservice.component.css']
})
export class HomeTechnicalserviceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technicalservice/components/home-technicalservice/home-technicalservice.component.ts